import { useIntl } from 'react-intl';
import { QueryStatus } from '@tanstack/react-query';

import { Block } from '../shared/Block';
import { Notification } from '../../../resources/notifications/types';

import { NotificationsContent } from './NotificationsContent';

type NotificationsBlockProps = {
    areNotificationsLoading: boolean;
    notifications: Notification[] | undefined;
    notificationsStatus: QueryStatus;
};

export const NotificationsBlock = ({
    areNotificationsLoading,
    notifications = [],
    notificationsStatus,
}: NotificationsBlockProps) => {
    const { formatMessage } = useIntl();
    const unreadNotificationsCount = notifications.filter(
        (notification) => !notification.read,
    ).length;

    return (
        <Block
            title={formatMessage(
                { id: 'homepage.notifications.title' },
                { count: unreadNotificationsCount },
            )}
            sx={{ minHeight: { xs: '20rem', md: '36rem' } }}
        >
            <NotificationsContent
                areNotificationsLoading={areNotificationsLoading}
                notifications={notifications}
                notificationsStatus={notificationsStatus}
            />
        </Block>
    );
};
